<template>
  <div style="padding: 0 30px; font-size: 14px">
    <div class="pdfContainer">
      <img
        v-if="!isHasPDF"
        src="@/static/images/u394.svg"
        alt=""
        style="width: 100%"
      />
      <div v-if="!isHasPDF" class="desc">知识点对照表PDF文件预览</div>
      <div style="text-align: center">
        <object :data="fileSrc" type="application/pdf" width="800" height="800">
          This browser does not support PDFs. Please download the PDF to view it: 
          <a :href="fileSrc">Download PDF</a>
        </object>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/courseware/checkCourseware'
import * as api2 from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType'],
  data() {
    return {
      courseId: this.$route.query.courseId,
      courseWareId: '',
      fileSrc: '',
      isHasPDF: false,
    }
  },
  created() {
    this.getCourseWareId()
  },
  computed: {
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    getCourseWareId() {
      api2.getCourseId({ courseId: this.courseId }).then(({ data }) => {
        this.courseWareId = data
        this.reviewUploadPDF()
      })
    },

    reviewUploadPDF() {
      const refId = this.courseId + '_' + this.courseWareId
      api.reviewUploadPDF(refId).then(({ data }) => {
        if (data.code === 100000 && data.data !== null) {
          this.fileSrc = data.data.url
          this.isHasPDF = true
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.pdfContainer {
  position: relative;
  .desc {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -300%);
    font-size: 28px;
  }
}
</style>